export const publicContainer = {
  name: 'Container Công Khai |||| Container Công Khai',
  fields: {
    title: 'Thông tin Container',
    containerCode: 'Mã container',
    totalShipments: 'Tổng số lô hàng',
    totalWeight: 'Tổng trọng lượng',
    totalVolume: 'Tổng thể tích',
    shipmentsList: 'Danh sách lô hàng',
    orderInfo: 'Thông tin đơn hàng',
    images: 'Hình ảnh',
    notes: 'Ghi chú',
    productName: 'Tên sản phẩm',
    numberOfPacks: 'Số kiện',
    totalDimension: 'Tổng thể tích',
    totalWeightColumn: 'Tổng trọng lượng',
    status: 'Trạng thái',
    orderCreatedDate: 'Ngày tạo đơn',
    shipmentCreatedDate: 'Ngày tạo lô',
    confirmationImage: 'Ảnh xác nhận',
    noImages: 'Không có hình ảnh',
    noShipments: 'Không có lô hàng nào trong container này.',
    invalidCode: 'Mã container không hợp lệ hoặc đã hết hạn',
    missingCode: 'Không tìm thấy mã container trong URL',
    loadingError: 'Lỗi khi tải dữ liệu',
    index: 'STT',
    mvd: 'MVD',
    order: 'Đơn hàng',
    shipment: 'Lô hàng',
    inWarehouse: 'Trong kho',
  },
  statuses: {
    ALL: 'Tất cả',
    IN_FROM_WAREHOUSE: 'Trong kho nguồn',
    TURN_AROUND: 'Hàng quay đầu',
    LOADING: 'Đang xếp container',
    IN_CONT: 'Trong container',
    DEPARTED: 'Khởi hành',
    ARRIVED: 'Cập cảng',
    RETURNED: 'Về kho',
    IN_TO_WAREHOUSE: 'Trong kho đích',
    ON_DELIVERY: 'Đang giao hàng',
    DELIVERED: 'Đã giao hàng',
    COMPLETED: 'Hoàn thành',
    LOST: 'Thất lạc',
  },
}
